import { useContext, useState } from "react";
import plur from "plur";
import { Flex, Text, Button } from "@jsq/ds/core";
import {
  actionsContainer,
  container,
  header,
} from "~/pages/UserAndRoles/UsersPage/components/UsersTable/components/style_vanilla.css";
import { SPACING } from "~/styles/variables";
import AddUserModal from "../../AddUserModal";
import RemoveUserBulkModal from "../../BulkRemoveUserModal";
import { WorkspacesTableContext } from "../hooks/useSelectRows";

export const BulkActionsPanel = ({
  onClear,
  width,
}: {
  onClear: () => void;
  width: number;
}) => {
  const { selectedRows } = useContext(WorkspacesTableContext);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showRemoveUserModal, setShowRemoveUserModal] = useState(false);

  return (
    <Flex flexDirection="column" className={container} style={{ width }}>
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        className={header}
      >
        <Text variant="regular-md">{`${selectedRows.length} ${plur("workspace", selectedRows.length)} selected`}</Text>
        <Button onClick={onClear} variant="link" displayAsLink>
          Clear selection
        </Button>
      </Flex>

      <Flex flexDirection="column" gap={SPACING.MEDIUM} className={actionsContainer}>
        <Text variant="secondary-sm">USERS</Text>
        <Button
          displayAsLink
          onClick={() => setShowAddUserModal(true)}
          variant="custom"
          textColor="primary"
          disabled={selectedRows.length <= 0}
        >
          Assign user
        </Button>
        <Button
          displayAsLink
          onClick={() => setShowRemoveUserModal(true)}
          variant="custom"
          textColor="primary"
          disabled={selectedRows.length <= 0}
        >
          Remove user
        </Button>
      </Flex>
      <AddUserModal
        isOpen={showAddUserModal}
        onClose={() => setShowAddUserModal(false)}
        selectedWorkspaces={selectedRows}
      />
      <RemoveUserBulkModal
        isOpen={showRemoveUserModal}
        onClose={() => setShowRemoveUserModal(false)}
        selectedWorkspaces={selectedRows}
      />
    </Flex>
  );
};
